import axios from "axios";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_URL_API_BACK,
  headers: {
    "Content-Type": "application/json"
  }
});

apiClient.interceptors.request.use(

  async (config) => {

    const currentUser = auth.currentUser;

    if (currentUser) {
      const token = await currentUser.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;

  },

  (error) => Promise.reject(error)

);

apiClient.interceptors.response.use(

  (response) => response,

  async (error) => {

    if (error.response?.status === 401) {
      try {
        await signOut(auth);
      } catch (_) {}
      window.location.href = '/';
    }

    return Promise.reject(error);

  }

);

export default apiClient;
